/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios';
import store from '@/store';
import { Toast } from 'vant';

// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//     axios.defaults.baseURL = window.location.href.split("/kingdee/")[0];
// }
// else if (process.env.NODE_ENV == 'debug') {
//     axios.defaults.baseURL = window.location.href.split("/kingdee/")[0];
// }
// else if (process.env.NODE_ENV == 'production') {
    //配置接口域名
    //axios.defaults.baseURL = window.location.href.split("/kingdee/")[0];
// }

//配置接口域名(http://localhost:8080/ierp/kingdee/scm/mainpagenew/mainpage.html#/)
axios.defaults.baseURL = window.location.href.split("/kingdee/")[0];

/**
 * 提示函数
 * 禁止点击蒙层、显示一秒后关闭
 */
const tip = msg => {
    Toast({
        message: msg,
        duration: 1000,
        forbidClick: true
    });
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
    // 状态码判断
    switch (status) {
        // 403 token过期
        // 清除token并跳转登录页
        case 403:
            tip('登录过期，请重新登录');
            localStorage.removeItem('token');
            store.commit('loginSuccess', null);
            setTimeout(() => {
                toLogin();
            }, 1000);
            break;
        // 404请求不存在
        case 404:
            tip('请求的资源不存在');
            break;
        case 302:
            tip('跨域了');
            break;
        default:
            console.log(other);
    }
}

// 创建axios实例
var instance = axios.create({ timeout: 1000 * 12 });
// 设置post请求头
// instance.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
instance.defaults.headers.post['Content-Type'] = 'application/json';
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
    config => {
        return config;
    },
    error => Promise.error(error));

// 响应拦截器
instance.interceptors.response.use(
    // 请求成功
    res => res.status === 200 ? Promise.resolve(res) : Promise.reject(res),
    // 请求失败
    error => {
        const { response } = error;
        if (response) {
            // 请求已发出，但是不在2xx的范围
            errorHandle(response.status, response.data.message);
            return Promise.reject(response);
        }
    });

export default instance;